import React from 'react'
import logo from '../../../assets/static/logo-muvibus.png'

const LogotipoMuvibus = () => (
	<img className="logotipo-muvibus" src={logo} alt="Logotipo muvibus" />
)

export default LogotipoMuvibus
